// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"92eb9870","524":"92eb9870"}[chunkId] + ".chunk.css";
};